export enum ReasonCancelSession {
  clientDidNotPay = 'clientDidNotPay',
  clientCancel = 'clientCancel',
}